export const siteMeta = {
  name: '黑料专区',
  tagline: '深扒内情 · 还原真相',
  slogan: '把热点拆开看，才看得见里面的齿轮。',
  description:
    '我们不做情绪的二传手。黑料专区围绕娱乐行业的运行机制与热点事件的传播链路，逐层拆解事件是怎么发生、又是如何被放大的，让每一个热闹都有迹可循。',
  email: 'tips@heiliao-zhuanqu.com',
  buildTime: '2026-09-10',
};

export const heroStats = [
  { id: 'stat-1', label: '深度观察文章', value: '1280', suffix: '篇' },
  { id: 'stat-2', label: '拆解热点事件', value: '436', suffix: '起' },
  { id: 'stat-3', label: '线索来源核验', value: '92', suffix: '% 通过率' },
  { id: 'stat-4', label: '平均阅读完成率', value: '76', suffix: '%' },
];

export const tickerItems = [
  '一档爆款综艺的剪辑台前：叙事是如何被"造"出来的',
  '热播剧口碑两极分化，问题真的出在演员身上吗',
  '从热搜到冷处理：一次舆情事件的完整传播链路',
  '经纪公司的合约逻辑：新人为什么这么难解约',
  '番位之争背后：片方、平台与演员的三方博弈',
  '数据注水的三种常见形态与识别方法',
];

export const categories = [
  {
    id: 'cat-film',
    slug: 'film',
    name: '影视幕后',
    desc: '从立项、选角到后期，拆解一部剧从剧本到上线的真实流程。',
    count: 268,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20cinematic%20film%20set%20with%20a%20vintage%20clapperboard%20and%20director%20chair%20under%20soft%20studio%20lights%2C%20editorial%20photography%2C%20simple%20dark%20background%2C%20high%20detail%2C%20harmonious%20composition&width=700&height=700&seq=hlzq-cat-film&orientation=squarish',
  },
  {
    id: 'cat-variety',
    slug: 'variety',
    name: '综艺观察',
    desc: '综艺的看点从哪里来？聊聊赛制设计、剪辑节奏与人设搭建。',
    count: 179,
    image:
      'https://readdy.ai/api/search-image?query=Modern%20television%20studio%20with%20rows%20of%20warm%20spotlights%20and%20empty%20stage%20markings%2C%20moody%20editorial%20photography%2C%20deep%20shadows%20and%20golden%20glow%2C%20simple%20clean%20background%2C%20high%20detail&width=700&height=700&seq=hlzq-cat-variety&orientation=squarish',
  },
  {
    id: 'cat-opinion',
    slug: 'opinion',
    name: '舆情分析',
    desc: '一个话题如何从零星讨论变成全民围观，链路可以被复盘。',
    count: 214,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20with%20warm%20amber%20graphs%20and%20network%20nodes%20on%20a%20dark%20charcoal%20surface%2C%20minimal%20editorial%20style%2C%20soft%20glow%2C%20high%20contrast%2C%20clean%20composition&width=700&height=700&seq=hlzq-cat-opinion&orientation=squarish',
  },
  {
    id: 'cat-agency',
    slug: 'agency',
    name: '经纪生态',
    desc: '合约、分成、解约与资源分配，一套环环相扣的行业规则。',
    count: 142,
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20signed%20contract%20documents%20with%20a%20pen%20on%20a%20warm%20wooden%20desk%20under%20dim%20lamplight%2C%20editorial%20still%20life%20photography%2C%20muted%20warm%20tones%2C%20simple%20dark%20background%2C%20high%20detail&width=700&height=700&seq=hlzq-cat-agency&orientation=squarish',
  },
  {
    id: 'cat-fandom',
    slug: 'fandom',
    name: '粉丝文化',
    desc: '控评、反黑、应援与数据打投，注意力经济下的群体行为。',
    count: 156,
    image:
      'https://readdy.ai/api/search-image?query=Crowd%20of%20silhouettes%20holding%20up%20glowing%20phone%20lights%20in%20a%20dark%20venue%2C%20warm%20amber%20glow%2C%20editorial%20concert%20photography%2C%20moody%20atmosphere%2C%20clean%20dark%20background%2C%20high%20detail&width=700&height=700&seq=hlzq-cat-fandom&orientation=squarish',
  },
  {
    id: 'cat-data',
    slug: 'data',
    name: '行业数据',
    desc: '用可核查的公开数据，看看热度、票房与招商的真实水位。',
    count: 121,
    image:
      'https://readdy.ai/api/search-image?query=Printed%20analytics%20reports%20and%20charts%20spread%20on%20a%20desk%20with%20a%20calculator%2C%20warm%20paper%20tones%2C%20editorial%20still%20life%2C%20soft%20window%20light%2C%20simple%20neutral%20background%2C%20high%20detail&width=700&height=700&seq=hlzq-cat-data&orientation=squarish',
  },
];

export const hotList = [
  {
    id: 'hot-1',
    rank: 1,
    title: '一档爆款综艺的剪辑台前：叙事是如何被"造"出来的',
    category: '综艺观察',
    heat: 98400,
    trend: 'up',
  },
  {
    id: 'hot-2',
    rank: 2,
    title: '热播剧口碑两极分化，问题真的出在演员身上吗',
    category: '影视幕后',
    heat: 87200,
    trend: 'up',
  },
  {
    id: 'hot-3',
    rank: 3,
    title: '从热搜到冷处理：一次舆情事件的完整传播链路',
    category: '舆情分析',
    heat: 82500,
    trend: 'flat',
  },
  {
    id: 'hot-4',
    rank: 4,
    title: '经纪公司的合约逻辑：新人为什么这么难解约',
    category: '经纪生态',
    heat: 71900,
    trend: 'up',
  },
  {
    id: 'hot-5',
    rank: 5,
    title: '番位之争背后：片方、平台与演员的三方博弈',
    category: '影视幕后',
    heat: 66300,
    trend: 'down',
  },
  {
    id: 'hot-6',
    rank: 6,
    title: '控评与反黑：一场没有硝烟的注意力战争',
    category: '粉丝文化',
    heat: 58700,
    trend: 'up',
  },
  {
    id: 'hot-7',
    rank: 7,
    title: '数据注水的三种常见形态与识别方法',
    category: '行业数据',
    heat: 51200,
    trend: 'down',
  },
  {
    id: 'hot-8',
    rank: 8,
    title: '剧集招商的账本：平台到底在为什么买单',
    category: '行业数据',
    heat: 46900,
    trend: 'flat',
  },
];

export const articleCategories = [
  { key: 'all', label: '全部' },
  { key: 'film', label: '影视幕后' },
  { key: 'variety', label: '综艺观察' },
  { key: 'opinion', label: '舆情分析' },
  { key: 'agency', label: '经纪生态' },
  { key: 'fandom', label: '粉丝文化' },
  { key: 'data', label: '行业数据' },
];

export const articles = [
  {
    id: 'art-1',
    slug: 'variety-editing-narrative',
    title: '一档爆款综艺的剪辑台前：叙事是如何被"造"出来的',
    excerpt:
      '同一场录制，为什么播出后观众记住的是完全不同的故事？我们从素材比例、节奏点与情绪线三个层面，复盘一档综艺的叙事是怎么被组装出来的。',
    categoryKey: 'variety',
    categoryName: '综艺观察',
    image:
      'https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20on%20a%20large%20monitor%20in%20a%20dim%20warm%20studio%2C%20waveform%20and%20clip%20blocks%20visible%2C%20editorial%20photography%2C%20deep%20shadows%20with%20amber%20glow%2C%20simple%20dark%20background%2C%20high%20detail&width=900&height=640&seq=hlzq-art-variety-edit&orientation=landscape',
    date: '2026-09-08',
    readTime: '9 分钟',
    author: '编辑部 · 沈见',
    tags: ['剪辑节奏', '叙事结构', '赛制设计'],
    featured: true,
  },
  {
    id: 'art-2',
    slug: 'drama-reputation-split',
    title: '热播剧口碑两极分化，问题真的出在演员身上吗',
    excerpt:
      '评分从 8.1 一路掉到 6.4，讨论却集中在几位主演身上。把剧本完成度、拍摄周期和后期调色放在一起看，答案往往不在最显眼的地方。',
    categoryKey: 'film',
    categoryName: '影视幕后',
    image:
      'https://readdy.ai/api/search-image?query=Film%20production%20monitor%20showing%20a%20dramatic%20scene%20on%20a%20dark%20set%2C%20warm%20amber%20key%20light%2C%20editorial%20photography%2C%20moody%20atmosphere%2C%20simple%20dark%20background%2C%20high%20detail%2C%20cinematic%20composition&width=900&height=640&seq=hlzq-art-drama-review&orientation=landscape',
    date: '2026-09-06',
    readTime: '11 分钟',
    author: '编辑部 · 陆迟',
    tags: ['剧集制作', '剧本完成度', '口碑分析'],
    featured: true,
  },
  {
    id: 'art-3',
    slug: 'public-opinion-chain',
    title: '从热搜到冷处理：一次舆情事件的完整传播链路',
    excerpt:
      '一条模糊的爆料，如何在 6 小时内完成从小圈层到全网热搜的跃迁？我们把传播节点逐一标注，看清每一次加速发生在哪里。',
    categoryKey: 'opinion',
    categoryName: '舆情分析',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20network%20graph%20of%20connected%20nodes%20and%20rising%20trend%20lines%20in%20warm%20amber%20on%20a%20dark%20charcoal%20surface%2C%20minimal%20editorial%20data%20visualization%2C%20soft%20glow%2C%20high%20contrast&width=900&height=640&seq=hlzq-art-opinion-chain&orientation=landscape',
    date: '2026-09-05',
    readTime: '8 分钟',
    author: '编辑部 · 何叙',
    tags: ['传播链路', '热搜机制', '舆情复盘'],
    featured: true,
  },
  {
    id: 'art-4',
    slug: 'agency-contract-logic',
    title: '经纪公司的合约逻辑：新人为什么这么难解约',
    excerpt:
      '签约时一页纸讲完的承诺，解约时却要翻出十几条条款。我们用一份典型合约结构，解释资源投入、违约金与培养周期之间的绑定关系。',
    categoryKey: 'agency',
    categoryName: '经纪生态',
    image:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20contract%20clauses%20and%20a%20signature%20line%20on%20warm%20paper%2C%20pen%20resting%20nearby%2C%20editorial%20still%20life%2C%20muted%20warm%20tones%2C%20shallow%20depth%20of%20field%2C%20simple%20neutral%20background&width=900&height=640&seq=hlzq-art-agency-contract&orientation=landscape',
    date: '2026-09-03',
    readTime: '10 分钟',
    author: '编辑部 · 苏木',
    tags: ['经纪合约', '违约金', '艺人培养'],
  },
  {
    id: 'art-5',
    slug: 'billing-order-battle',
    title: '番位之争背后：片方、平台与演员的三方博弈',
    excerpt:
      '海报上名字的左右顺序，为什么能让几方僵持数周？番位不只是面子问题，它直接关联招商定价、宣传资源与后续片酬谈判。',
    categoryKey: 'film',
    categoryName: '影视幕后',
    image:
      'https://readdy.ai/api/search-image?query=Stack%20of%20movie%20poster%20proofs%20and%20layout%20prints%20on%20a%20design%20desk%20under%20warm%20lamp%20light%2C%20editorial%20still%20life%2C%20muted%20amber%20tones%2C%20simple%20dark%20background%2C%20high%20detail&width=900&height=640&seq=hlzq-art-billing-order&orientation=landscape',
    date: '2026-09-01',
    readTime: '7 分钟',
    author: '编辑部 · 陆迟',
    tags: ['番位', '招商定价', '宣传资源'],
  },
  {
    id: 'art-6',
    slug: 'fandom-attention-war',
    title: '控评与反黑：一场没有硝烟的注意力战争',
    excerpt:
      '当一条负面评价出现，最快 3 分钟内就会被大量正面内容覆盖。我们梳理控评的常见组织形式，以及它对普通观众判断的影响。',
    categoryKey: 'fandom',
    categoryName: '粉丝文化',
    image:
      'https://readdy.ai/api/search-image?query=Hands%20holding%20glowing%20smartphones%20in%20a%20dark%20crowd%2C%20warm%20amber%20screen%20light%20on%20faces%2C%20editorial%20photography%2C%20moody%20atmosphere%2C%20simple%20dark%20background%2C%20high%20detail&width=900&height=640&seq=hlzq-art-fandom-war&orientation=landscape',
    date: '2026-08-30',
    readTime: '9 分钟',
    author: '编辑部 · 何叙',
    tags: ['控评', '反黑', '注意力经济'],
  },
  {
    id: 'art-7',
    slug: 'data-inflation-signs',
    title: '数据注水的三种常见形态与识别方法',
    excerpt:
      '播放量、互动数与讨论度，看起来都在涨，但涨幅曲线会说话。我们把三种典型注水形态摊开，给出普通人也能用的识别办法。',
    categoryKey: 'data',
    categoryName: '行业数据',
    image:
      'https://readdy.ai/api/search-image?query=Printed%20analytics%20charts%20with%20unusually%20smooth%20growth%20curves%20on%20warm%20paper%2C%20magnifying%20glass%20resting%20on%20top%2C%20editorial%20still%20life%2C%20amber%20highlights%2C%20simple%20neutral%20background&width=900&height=640&seq=hlzq-art-data-inflation&orientation=landscape',
    date: '2026-08-28',
    readTime: '8 分钟',
    author: '编辑部 · 苏木',
    tags: ['播放量', '互动数据', '识别方法'],
  },
  {
    id: 'art-8',
    slug: 'platform-advertising-ledger',
    title: '剧集招商的账本：平台到底在为什么买单',
    excerpt:
      '一部剧未播先火，招商就已完成大半。拆开招商结构你会发现，平台买的从来不只是内容本身，而是一整套可预期的注意力。',
    categoryKey: 'data',
    categoryName: '行业数据',
    image:
      'https://readdy.ai/api/search-image?query=Financial%20spreadsheets%20and%20a%20laptop%20showing%20bar%20charts%20on%20a%20warm%20wooden%20desk%2C%20editorial%20still%20life%2C%20muted%20amber%20tones%2C%20soft%20lamp%20light%2C%20simple%20neutral%20background&width=900&height=640&seq=hlzq-art-ad-ledger&orientation=landscape',
    date: '2026-08-26',
    readTime: '9 分钟',
    author: '编辑部 · 沈见',
    tags: ['招商', '平台策略', '注意力经济'],
  },
  {
    id: 'art-9',
    slug: 'variety-casting-logic',
    title: '综艺选人的底层逻辑：为什么总是那几张熟悉的脸',
    excerpt:
      '新人上不去、老面孔反复出现，不完全是制作方保守。从招商信心、录制风险到话题稳定性，选角是一道被预算约束的算术题。',
    categoryKey: 'variety',
    categoryName: '综艺观察',
    image:
      'https://readdy.ai/api/search-image?query=Empty%20audition%20room%20with%20a%20single%20chair%20under%20a%20warm%20spotlight%20and%20camera%20on%20tripod%2C%20editorial%20photography%2C%20moody%20atmosphere%2C%20deep%20shadows%2C%20simple%20dark%20background%2C%20high%20detail&width=900&height=640&seq=hlzq-art-variety-casting&orientation=landscape',
    date: '2026-08-24',
    readTime: '10 分钟',
    author: '编辑部 · 苏木',
    tags: ['选角', '预算约束', '话题稳定性'],
  },
  {
    id: 'art-10',
    slug: 'opinion-cold-handling',
    title: '冷处理为什么经常有效：沉默也是一种回应',
    excerpt:
      '面对争议，有些团队选择高频回应，有些则完全沉默。两种策略的成败差异，往往取决于议题是否存在自我消耗的生命周期。',
    categoryKey: 'opinion',
    categoryName: '舆情分析',
    image:
      'https://readdy.ai/api/search-image?query=A%20quiet%20empty%20newsroom%20desk%20with%20a%20single%20old%20telephone%20and%20stacked%20papers%2C%20dim%20warm%20lighting%2C%20editorial%20photography%2C%20muted%20amber%20tones%2C%20simple%20dark%20background&width=900&height=640&seq=hlzq-art-cold-handling&orientation=landscape',
    date: '2026-08-22',
    readTime: '7 分钟',
    author: '编辑部 · 何叙',
    tags: ['危机公关', '回应策略', '议题生命周期'],
  },
];

export const spotlight = {
  id: 'spotlight-1',
  kicker: '深度专题',
  title: '一部剧从立项到上线，会经过多少道"看不见的手"',
  summary:
    '我们跟踪了一个剧集项目 14 个月的时间线：从题材备案、平台评级、演员洽谈，到拍摄周期被压缩、后期返工与最终排播。每一个环节都在改变观众看到的样子。',
  points: [
    '立项阶段：题材方向如何被平台评级直接影响预算档位',
    '拍摄阶段：周期压缩如何传导到成片质量',
    '后期阶段：剪辑与调色在有限时间里的取舍逻辑',
    '排播阶段：档期选择与竞争环境如何影响最终热度',
  ],
  image:
    'https://readdy.ai/api/search-image?query=Long%20horizontal%20film%20production%20timeline%20visualized%20as%20connected%20warm%20amber%20milestone%20markers%20on%20a%20dark%20charcoal%20wall%2C%20minimal%20editorial%20infographic%20style%2C%20soft%20glow%2C%20high%20contrast%2C%20clean%20composition&width=1300&height=860&seq=hlzq-spotlight-timeline&orientation=landscape',
  footnote: '专题内容基于公开资料与行业访谈整理，共 6400 字，阅读约 18 分钟。',
};

export const faqs = [
  {
    id: 'faq-1',
    q: '黑料专区的内容主要讲什么？',
    a: '我们聚焦娱乐行业的运行机制与热点事件的传播链路，从影视幕后、综艺制作、舆情演化、经纪模式到粉丝文化，逐层拆解事件是怎么发生、又是如何被放大的。',
  },
  {
    id: 'faq-2',
    q: '内容会指向具体的真实个人吗？',
    a: '不会。我们坚持对事不对人的原则，内容以行业现象、公开信息与流程机制为主，不使用未经核实的个人指控，也不鼓励针对任何个体的攻击行为。',
  },
  {
    id: 'faq-3',
    q: '如何向黑料专区提供线索？',
    a: '可以通过页面底部的投稿入口提交线索说明与联系方式。编辑团队会先核验来源与可查证材料，再决定是否进入选题流程。',
  },
  {
    id: 'faq-4',
    q: '黑料专区的内容多久更新一次？',
    a: '深度观察类内容通常在工作日更新，热点事件发生时会临时加更深度拆解。首页的深扒榜每日刷新一次热度排序。',
  },
  {
    id: 'faq-5',
    q: '如果发现内容有误，可以申请更正吗？',
    a: '可以。请通过投稿入口提交更正说明并提供可核实的依据，我们核实后会在原文顶部标注更正说明，并同步调整相关表述。',
  },
];

export const brandValues = [
  {
    id: 'value-1',
    icon: 'ri-search-eye-line',
    title: '先核验，再表达',
    desc: '每一条进入选题的线索，都要经过来源核验与交叉比对，宁可慢一天，也不做未经确认的判断。',
  },
  {
    id: 'value-2',
    icon: 'ri-links-line',
    title: '讲清链路',
    desc: '比起抛出结论，我们更愿意把一个事件的传播链条完整摊开，让读者自己看到关键节点在哪里。',
  },
  {
    id: 'value-3',
    icon: 'ri-scales-3-line',
    title: '对事不对人',
    desc: '我们讨论机制与现象，不针对任何个体。涉及具体对象时，只采用可公开查证的信息与材料。',
  },
  {
    id: 'value-4',
    icon: 'ri-refresh-line',
    title: '有错就改',
    desc: '内容出现偏差时，我们会在原文标注更正说明并同步修订，把处理过程留在页面上，接受长期检验。',
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '林一舟',
    role: '影视行业从业者',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20portrait%20of%20a%20thoughtful%20young%20man%20in%20a%20dark%20shirt%2C%20soft%20studio%20lighting%2C%20minimal%20dark%20background%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=hlzq-avatar-01&orientation=squarish',
    quote:
      '难得有平台愿意把行业流程讲清楚，而不是只抛结论。做项目的时候我甚至会拿这里的拆解去对照自己的工作节点。',
  },
  {
    id: 't-2',
    name: '周敏',
    role: '长期读者',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20portrait%20of%20a%20calm%20young%20woman%20with%20short%20hair%2C%20soft%20studio%20lighting%2C%20minimal%20dark%20background%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=hlzq-avatar-02&orientation=squarish',
    quote:
      '看热闹和看懂是两回事。这里的舆情复盘那几篇，帮我把"为什么突然就全网都在说"这件事真正想明白了。',
  },
  {
    id: 't-3',
    name: '陈亦航',
    role: '内容运营',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20portrait%20of%20a%20focused%20young%20woman%20in%20a%20dark%20jacket%2C%20soft%20studio%20lighting%2C%20minimal%20dark%20background%2C%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=hlzq-avatar-03&orientation=squarish',
    quote:
      '他们的内容密度很高，但不堆术语。做选题的时候，这里的结构拆解经常能给我一个完全不同的切入点。',
  },
];

export const contactChannels = [
  {
    id: 'ch-1',
    icon: 'ri-mail-send-line',
    label: '线索投稿',
    value: 'tips@heiliao-zhuanqu.com',
    desc: '欢迎提供可核验的公开材料与线索说明',
  },
  {
    id: 'ch-2',
    icon: 'ri-question-answer-line',
    label: '内容更正',
    value: 'correct@heiliao-zhuanqu.com',
    desc: '发现表述有误？附上依据，我们核实后处理',
  },
  {
    id: 'ch-3',
    icon: 'ri-time-line',
    label: '更新节奏',
    value: '工作日 10:00 / 18:00 更新',
    desc: '重大热点事件期间会临时加更深度拆解',
  },
];

export const footerLinks = [
  { id: 'fl-1', label: '本周深扒榜', href: '#hot' },
  { id: 'fl-2', label: '主题分类', href: '#topics' },
  { id: 'fl-3', label: '精选内容', href: '#articles' },
  { id: 'fl-4', label: '深度专题', href: '#spotlight' },
  { id: 'fl-5', label: '常见问题', href: '#faq' },
  { id: 'fl-6', label: '关于与口碑', href: '#about' },
  { id: 'fl-7', label: '投稿订阅', href: '#contact' },
];